<template>
  <div v-if="oldMatter">
    <ul>
      <li
        v-for="strategy in methodologicalStrategyList"
        :key="`strategy-${strategy.id}`"
        :title="$htmlToPlainText(strategy.description)"
      >
        {{ strategy.name }}
      </li>
    </ul>
    <div
      v-can="'teaching.change_matter'"
      v-if="allows_crud && !isNaN(ProfileMatter.id)"
    >
      <!-- class="button-div" -->
      <ButtonSmall
        :tooltip_text="`${$t('reusable.common.edit')} ${$getVisibleNames(
          'mesh.methodologicalstrategy',
          false,
          'Estrategias Metodológicas'
        )}`"
        :click_button="
          () =>
            $bvModal.show(`modal-methodological-strategy-${ProfileMatter.id}`)
        "
        :icon="'square'"
      ></ButtonSmall>
      <b-modal
        :title="`${$t('reusable.common.selectLabel')} ${$getVisibleNames(
          'mesh.methodologicalstrategy',
          true,
          'Estrategias Metodológicas'
        )}`"
        :id="`modal-methodological-strategy-${ProfileMatter.id}`"
        @hidden="closeMethodologicalStrategy(ProfileMatter.id)"
        size="lg"
      >
        <template v-slot:modal-header>
          <div class="container-title-info d-flex">
            <h5>
              {{ $t("reusable.common.selectLabel") }}
              {{
                $getVisibleNames(
                  "mesh.methodologicalstrategy",
                  true,
                  "Estrategias Metodológicas"
                )
              }}
            </h5>
            <InfoTooltip
              class="ml-1 mt-1"
              :tooltip_text="$t('matrix1.matrix1View.multipleSelectionTooltip')"
            >
            </InfoTooltip>
          </div>
        </template>
        <b-input-group class="mb-1">
          <b-form-input
            v-model="input_search"
            type="search"
            size="sm"
            :placeholder="`${$t('reusable.common.search')} ${$getVisibleNames(
              'mesh.methodologicalstrategy',
              true,
              'Estrategias Metodológicas'
            )}...`"
          >
          </b-form-input>
          <b-input-group-append>
            <b-button
              :disabled="!input_search"
              @click="input_search = ''"
              size="sm"
              >{{ $t("reusable.common.clear") }}</b-button
            >
          </b-input-group-append>
        </b-input-group>
        <!-- v-model="methodological_strategies" -->
        <b-form-select
          :value="methodological_strategies"
          @change="onMethodologicalStrategiesChange"
          size="sm"
          :select-size="methodologicalStrategySort.length + 1"
          multiple
        >
          <b-form-select-option
            value="__clear__"
            >— {{ $t("reusable.common.clear") }} —</b-form-select-option
          >
          <b-form-select-option
            v-for="item in searchMethodologicalStrategies"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</b-form-select-option
          >
        </b-form-select>
        <template v-slot:modal-footer>
          <b-button
            class="btn-cancel"
            size="sm"
            @click="closeMethodologicalStrategy(ProfileMatter.id)"
            >{{ $t("reusable.common.cancel") }}</b-button
          >
          <b-button
            size="sm"
            @click="updateMethodologicalStrategy(ProfileMatter.id)"
            >{{ $t("reusable.common.save") }}</b-button
          >
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";

export default {
  name: "MethodologicalStrategiesCell",
  components: {
    InfoTooltip: () => import("@/components/reusable/InfoTooltip"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
  },
  props: {
    ProfileMatter: {
      type: Object,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      methodological_strategies: [],
      input_search: "",
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      matters: names.MATTERS,
      methodologicalStrategies: names.METHODOLOGICAL_STRATEGIES,
      studyUnits: names.STUDY_UNITS,
    }),
    oldMatter() {
      if (!this.ProfileMatter) return null;
      return this.matters.find((x) => x.id == this.ProfileMatter.matter);
    },
    filterStudyUnit() {
      if (!this.ProfileMatter) return [];
      return this.studyUnits.filter(
        (x) => x.matter == this.ProfileMatter.matter
      );
    },
    methodologicalStrategySort() {
      const list = this.methodologicalStrategies.filter(
        (x) => x.is_active || this.methodological_strategies.includes(x.id)
      );
      return list.sort(function (a, b) {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
    },
    methodologicalStrategyList() {
      let list = [];
      this.oldMatter.methodological_strategies.forEach((element) => {
        let instance = this.methodologicalStrategies.find(
          (x) => x.id == element
        );
        if (instance) list.push(instance);
      });
      return list;
    },
    searchMethodologicalStrategies: function () {
      return this.methodologicalStrategySort
        .filter((item) => {
          return (
            this.$filtered(item.name, this.input_search) ||
            this.methodological_strategies.includes(item.id)
          );
        })
        .sort(function (a, b) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
    },
  },
  methods: {
    onMethodologicalStrategiesChange(val) {
      if (val.includes("__clear__")) {
        this.methodological_strategies = [];
      } else {
        this.methodological_strategies = val;
      }
    },
    async updateStudyUnit() {
      for await (let study_unit of this.filterStudyUnit) {
        await this.$store.dispatch(names.PATCH_STUDY_UNIT, {
          study_unit_id: study_unit.id,
          item: {
            methodological_strategies: this.methodological_strategies,
          },
        });
      }
    },
    updateMethodologicalStrategy(profile_matter_id) {
      this.$store
        .dispatch(names.PATCH_MATTER, {
          matter_id: this.oldMatter.id,
          item: {
            methodological_strategies: this.methodological_strategies,
          },
        })
        .then(() => {
          if (
            !(this.institution && this.institution.internal_use_id == "duoc.cl")
          ) {
            this.updateStudyUnit();
          }
          this.$bvModal.hide(
            `modal-methodological-strategy-${profile_matter_id}`
          );
        });
    },
    closeMethodologicalStrategy(profile_matter_id) {
      this.methodological_strategies = this.oldMatter.methodological_strategies;
      this.$bvModal.hide(`modal-methodological-strategy-${profile_matter_id}`);
    },
  },
  // El fetch por id se hacia dos veces (created + mounted) para el mismo
  // matter: created() no aporta nada que mounted() no haga ya, asi que se
  // saca de aca (evita duplicar el loop en cada fila de la grilla).
  mounted() {
    if (this.oldMatter) {
      this.methodological_strategies = this.oldMatter.methodological_strategies;
      this.oldMatter.methodological_strategies.forEach((element) => {
        if (
          this.methodologicalStrategies.findIndex((x) => x.id == element) == -1
        )
          this.$store.dispatch(names.FETCH_METHODOLOGICAL_STRATEGY, element);
      });
    }
  },
};
</script>

<style scoped>
p,
li {
  font-size: var(--secondary-font-size);
}
ul {
  padding-left: 5px;
  margin-left: 10px;
  text-align: justify;
}
.button-div {
  position: absolute;
  bottom: 0;
  text-align: center;
  width: 100%;
}
.container-title-info {
  display: flex;
  justify-content: space-between;
}
.btn-cancel {
  margin-right: auto;
  margin-left: 0.3em;
}
@media (max-width: 991px) {
}
</style>